import { findFollowUpChecked } from "./followUps";

/**
 * Build API payload selections from all question sections (same shape as legacy handler).
 *
 * @param {NodeListOf<Element>|Element[]} sections
 * @returns {{ ok: true, selections: object[] } | { ok: false, errorPayload: object }}
 */
export function buildSelections(sections) {
  const selections = [];

  for (let i = 0; i < sections.length; i++) {
    const section = sections[i];
    const q = parseInt(section.getAttribute("data-question-index"), 10);
    const type = section.getAttribute("data-question-type") || "";

    if (type === "single-choice") {
      const mainSingle = section.querySelector("input[data-ps-main]:checked");

      if (!mainSingle) {
        return {
          ok: false,
          errorPayload: {
            error: "missing_selection",
            questionIndex: q,
            message: "Select an answer for each question (single choice)."
          }
        };
      }

      const answerIndexSingle = parseInt(
        mainSingle.getAttribute("data-answer-index"),
        10
      );
      const fuSingle = findFollowUpChecked(section, answerIndexSingle);
      let followUpSingle = null;

      if (fuSingle) {
        followUpSingle = parseInt(
          fuSingle.getAttribute("data-follow-up-index"),
          10
        );
      }

      selections.push({
        type: "single-choice",
        // eslint-disable-next-line camelcase
        answer_index: answerIndexSingle,
        // eslint-disable-next-line camelcase
        follow_up_index: followUpSingle
      });
    } else if (type === "multiple-choice") {
      const mains = section.querySelectorAll("input[data-ps-main]:checked");
      const answers = [];

      for (let j = 0; j < mains.length; j++) {
        const cb = mains[j];
        const answerIndexMc = parseInt(
          cb.getAttribute("data-answer-index"),
          10
        );
        const fuMc = findFollowUpChecked(section, answerIndexMc);
        let followUpMc = null;

        if (fuMc) {
          followUpMc = parseInt(fuMc.getAttribute("data-follow-up-index"), 10);
        }

        answers.push({
          // eslint-disable-next-line camelcase
          answer_index: answerIndexMc,
          // eslint-disable-next-line camelcase
          follow_up_index: followUpMc
        });
      }

      if (answers.length === 0) {
        return {
          ok: false,
          errorPayload: {
            error: "missing_selection",
            questionIndex: q,
            message:
              "Select at least one answer for each multiple-choice question."
          }
        };
      }

      selections.push({
        type: "multiple-choice",
        answers: answers
      });
    }
  }

  return { ok: true, selections: selections };
}
